import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on réparer un moteur Bubendorff ou faut-il obligatoirement le changer ?",
    answer: "Dans certains cas, une réparation est possible. Si la panne provient d'une batterie solaire usée, d'un condensateur défectueux ou d'un problème de programmation radio, nous remplaçons seulement le composant concerné. En revanche, si le moteur intégré est grippé, si l'électronique embarquée est grillée ou si le rotor est bloqué mécaniquement, le remplacement complet est la seule solution durable. Notre diagnostic sur place permet de déterminer immédiatement la voie la plus économique et la plus fiable.",
  },
  {
    question: "Quel est le prix d'un remplacement de moteur Bubendorff ?",
    answer: "Le prix dépend du modèle de moteur, de sa puissance et de la configuration de votre installation. Un moteur Bubendorff d'origine avec batterie solaire et reprogrammation radio représente un investissement plus important qu'un moteur filaire standard. Nous établissons un devis gratuit et transparent avant toute intervention, sans surprise. Le diagnostic initial est offert et vous permet de connaître précisément les options disponibles ainsi que leur tarif respectif.",
  },
  {
    question: "Combien de temps dure l'intervention de remplacement ?",
    answer: "La plupart des remplacements de moteur Bubendorff sont réalisés en une seule visite d'environ 1h30 à 2h30. Cette durée inclut le diagnostic, la dépose du tablier, le remplacement du moteur, le recâblage ou la reprogrammation radio, le réglage des fins de course et les tests finaux. Si le moteur doit être commandé spécifiquement, nous vous donnons un délai d'approvisionnement et fixons un rendez-vous d'installation dès la réception de la pièce.",
  },
  {
    question: "Gardez-vous mes télécommandes Bubendorff existantes ?",
    answer: "Oui, nous faisons tout pour conserver vos télécommandes existantes. Lorsque nous installons un moteur compatible avec le protocole radio Bubendorff, nous reprogrammons simplement les télécommandes déjà en votre possession. Si le modèle de moteur nécessite un changement de protocole, nous vous proposons soit de migrer vers une télécommande universelle, soit de conserver vos anciennes télécommandes en parallèle. Nous vous expliquons toujours les options avant de procéder.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions fréquentes sur le moteur Bubendorff
        </h2>
        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="text-brand-blue font-semibold text-base md:text-lg pr-4">
                  {item.question}
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-brand-cyan flex-shrink-0">
                  <i
                    className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-xl`}
                  ></i>
                </span>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-brand-text leading-relaxed text-sm md:text-base">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}